export default "__VITE_ASSET__BrUCSBPd__"